// @ts-ignore
import { TARGETS, XDMWrapper } from '@gt-common/event-logger-web';
import { isCrawler } from '../utils/commonUtils';
import { BaseSchemaCabs, BaseCabsEvent } from './xdmSchema';
import { keysToGenerate } from './adobeKeyConfig';

export const analyticsSDK = XDMWrapper.initAndSetAnalyticsSdk({
  org: 'MMT'
});

export const logEventToXDM = (eventLogger: BaseCabsEvent) => {
  try {
    _logEventToXDM(eventLogger);
  } catch (e) {
    console.log('Error while XDM logging', e);
  }
};

const _logEventToXDM = async (eventLogger: BaseCabsEvent) => {
  if (!XDMWrapper.logEvent || isCrawler()) {
    return;
  }
  XDMWrapper.logEvent({
    payload: eventLogger,
    otherConfig: {
      lobName: 'cabs',
      adobeKeyConfig: keysToGenerate
    },
    target: TARGETS.ALL,
    extraOptions: {
      lob: 'cabs',
      destinationUrl: typeof window !== 'undefined' ? window.location.href : ''
    },
    schema: BaseSchemaCabs
  });
};
